(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-us"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header-us');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.placeholderHeader = document.getElementById('placeholder-header');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    scrollDownToo(){
      const sticky = this.offsetTop; 
      const currentColorScheme = this.dataset.colorScheme
      const changeToColorScheme = this.dataset.colorSchemeChange
      const megaNavs = this.querySelectorAll('.megaNav');
      if (window.pageYOffset > sticky) {
        this.classList.remove(`color-${currentColorScheme}`);
        this.classList.add("header-sticky",`color-${changeToColorScheme}`);
        this.placeholderHeader.classList.add("placeholder-visible");
        megaNavs.forEach(megaNav => {
          megaNav.classList.remove(`color-${currentColorScheme}`);
          megaNav.classList.add(`color-${changeToColorScheme}`)
        })
        return;
      }

      if(window.pageYOffset == 0){
        this.classList.add(`color-${currentColorScheme}`);
        this.classList.remove("header-sticky",`color-${changeToColorScheme}`);
        this.placeholderHeader.classList.remove("placeholder-visible");

        megaNavs.forEach(megaNav => {
          megaNav.classList.remove(`color-${changeToColorScheme}`);
          megaNav.classList.add(`color-${currentColorScheme}`);
        })
        return;
      }
    }

    bodyScrollTop() {
      return document.documentElement.scrollTop || document.body.scrollTop;
    }

    onScroll() {
      this.scrollDownToo();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.placeholderHeader = document.getElementById('placeholder-header');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    scrollDownToo(){
      const sticky = this.offsetTop; 
      const currentColorScheme = this.dataset.colorScheme
      const changeToColorScheme = this.dataset.colorSchemeChange
      const megaNavs = this.querySelectorAll('.megaNav');

      if (window.pageYOffset > sticky) {
        this.classList.remove(`color-${currentColorScheme}`);
        this.classList.add("header-sticky",`color-${changeToColorScheme}`);
        this.placeholderHeader.classList.add("placeholder-visible");
        megaNavs.forEach(megaNav => {
          megaNav.classList.remove(`color-${currentColorScheme}`);
          megaNav.classList.add(`color-${changeToColorScheme}`);
        })
        return;
      }

      if(window.pageYOffset == 0){
        this.classList.add(`color-${currentColorScheme}`);
        this.classList.remove("header-sticky",`color-${changeToColorScheme}`);
        this.placeholderHeader.classList.remove("placeholder-visible");
        megaNavs.forEach(megaNav => {
          megaNav.classList.remove(`color-${changeToColorScheme}`);
          megaNav.classList.add(`color-${currentColorScheme}`);
        })
        return;
      }
    }

    bodyScrollTop() {
      return document.documentElement.scrollTop || document.body.scrollTop;
    }

    onScroll() {
      this.scrollDownToo();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  function check_announcement() {
    var has_announcement = document.querySelector(".announcement-bar");
    if (has_announcement != undefined) {
      document.querySelector("#shopify-section-header").classList.add("has-announcement-bar");
    }
  }

  check_announcement();

  } catch(e) { console.error(e); }
})();
})();
